import { AlertTriangle, Loader2 } from 'lucide-react';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export function UnsavedChangesModal({ isOpen, saving, onSave, onDiscard, onCancel }: UnsavedChangesModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-[2px] animate-[fadeIn_150ms_ease-out]"
        onClick={onCancel}
      />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full mx-4 p-6 animate-[scaleIn_200ms_ease-out]">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-2 bg-[#1875FF]/10 rounded-xl">
            <AlertTriangle className="w-5 h-5 text-[#1875FF]/70" />
          </div>
          <h3 className="text-lg font-extrabold text-gray-900 font-display">Unsaved Changes</h3>
        </div>

        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          You have unsaved changes that will be lost if you leave this page. Would you like to save them first?
        </p>

        <div className="flex gap-3">
          <button
            onClick={onDiscard}
            disabled={saving}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors disabled:opacity-50"
          >
            Discard
          </button>
          <button
            onClick={onSave}
            disabled={saving}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-[#1875FF] to-[#05E0D1] rounded-xl hover:shadow-lg hover:shadow-[#1875FF]/20 transition-all disabled:opacity-70"
          >
            {saving ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
